import './_horizontal-bar-chart.scss';
import { Chart } from 'chart.js/auto';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function HorizontalBarChart() {
    const dataChart = document.querySelector('.horizontal-chart-data') as HTMLElement;
    let data: any;
    const horizontalBarChart = document.querySelectorAll('.horizontal-bar-chart');

    if (horizontalBarChart.length > 0) {
        horizontalBarChart.forEach((bar, index) => {
            if (dataChart) {
                try {
                    data = JSON.parse(dataChart.innerHTML);
                } catch (e) {
                    data = [];
                }
            }

            function clearUi() {
                const titlesTooltip = bar.querySelectorAll('.tooltip-title');
                const descriptionsTooltip = bar.querySelectorAll('.tooltip-description');

                titlesTooltip && titlesTooltip.forEach(item => item.remove());
                descriptionsTooltip && descriptionsTooltip.forEach(item => item.remove());
            }

            const labelTooltip = bar.querySelector('.label-tooltip') as HTMLElement;
            const mask = bar.querySelector('.mask') as HTMLElement;

            function closeModal() {
                const icnClose = labelTooltip.querySelector('.icn-close') as HTMLElement;

                icnClose.addEventListener('click', () => {
                    mask.classList.add('d-none');
                    labelTooltip.classList.add('d-none');
                    document.body.style.overflow = 'scroll';
                });

                icnClose.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        mask.classList.add('d-none');
                        labelTooltip.classList.add('d-none');
                        document.body.style.overflow = 'scroll';
                    }
                });

                mask.addEventListener('click', () => {
                    mask.classList.add('d-none');
                    labelTooltip.classList.add('d-none');
                    document.body.style.overflow = 'scroll';
                });
            }

            closeModal();

            if (window.innerWidth >= 768) {
                let ctx = bar.querySelector('#horizontal-bar-chart-content') as any;
                // @ts-ignore
                const chart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: data.map((item: any) => item.label),
                        datasets: [
                            {
                                data: data.map((item: any) => item.values[0].value),
                                backgroundColor: data.map((item: any) => item.color[0]),
                                hoverBackgroundColor: data.map((item: any) => item.color[0]),
                            },
                            {
                                data: data.map((item: any) => item.values[1].value),
                                backgroundColor: data.map((item: any) => item.color[1]),
                                hoverBackgroundColor: data.map((item: any) => item.color[1]),
                            },
                        ],
                    },
                    options: {
                        indexAxis: 'y',
                        datasets: {
                            bar: {
                                barThickness: 40,
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        scales: {
                            x: {
                                grid: {
                                    display: true,
                                    color: '#ECE9F1',
                                    tickColor: 'transparent',
                                    tickLength: 39,
                                },
                                border: {
                                    display: false,
                                },
                                ticks: {
                                    autoSkipPadding: 50,
                                    callback: function (value) {
                                        return value + ' %';
                                    },
                                    display: true,
                                    color: '#030303',
                                    font: function (context) {
                                        var avgSize = Math.round((context.chart.height + context.chart.width) / 2);
                                        var size = Math.round(avgSize / 32);
                                        size = size > 17 ? 17 : size;
                                        return {
                                            size: size,
                                            weight: 'normal',
                                            family: "'Titillium Web', sans-serif",
                                        };
                                    },
                                },
                            },
                            y: {
                                grid: {
                                    display: false,
                                },
                                beginAtZero: false,
                                display: true,
                                ticks: {
                                    display: false,
                                },
                            },
                        },
                        plugins: {
                            tooltip: {
                                callbacks: {
                                    label: function (context) {
                                        let label = context.formattedValue;
                                        return label + '%';
                                    },
                                },
                                titleColor: '#000',
                                backgroundColor: '#FFF',
                                displayColors: false,
                                bodyColor: '#000',
                                enabled: true,
                            },
                            legend: {
                                display: false,
                            },
                        },
                    },
                });

                const labels = bar.querySelectorAll('.label-item .label');
                const labelWrapper = bar.querySelectorAll('.label-item');
                labels.forEach((_item: any, index: number) => {
                    labels[index].textContent += data[index]?.label;
                });

                labelWrapper.forEach(item => {
                    item.addEventListener('click', () => {
                        const label = item.querySelector('.label') as HTMLElement;
                        const find = data.filter((el: any) => el.tooltip.title === label.innerHTML);

                        if (find) {
                            clearUi();

                            mask.classList.remove('d-none');
                            labelTooltip.classList.remove('d-none');
                            document.body.style.overflow = 'hidden';

                            const title = document.createElement('div');
                            title.classList.add('tooltip-title');
                            const description = document.createElement('div');
                            description.classList.add('tooltip-description');
                            title.textContent += find.map((item: any) => item.tooltip.title);
                            description.textContent += find.map((item: any) => item.tooltip.description);

                            labelTooltip.appendChild(title);
                            labelTooltip.appendChild(description);
                        }
                    });
                });
            } else {
                const mobileCarousel = bar.querySelector('.mobile') as HTMLElement;
                const swiperContainer = mobileCarousel.querySelector('.swiper') as HTMLElement;
                swiperContainer.setAttribute('id', `swiper-${index}`);
                const swiperBtnNext = mobileCarousel.querySelector('.swiper-button-next') as HTMLElement;
                const swiperBtnPrev = mobileCarousel.querySelector('.swiper-button-prev') as HTMLElement;
                const slides = mobileCarousel.querySelectorAll('.swiper-slide');

                const swiper = new Swiper(swiperContainer, {
                    modules: [Navigation, Pagination],
                    slidesPerGroup: 1,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    navigation: {
                        nextEl: swiperBtnNext,
                        prevEl: swiperBtnPrev,
                        addIcons: false,
                    },
                });

                const charts = bar.querySelectorAll('.chart-container');
                charts.forEach((chart, index) => chart.setAttribute('id', `chart-${index}`));

                let ctx1 = bar.querySelector('#chart-mobile-1') as any;
                const chartMobile1 = mobileCarousel.querySelector('#chart-1') as HTMLElement;
                const labelFirstChart = chartMobile1.querySelector('.label') as HTMLElement;
                labelFirstChart.textContent += data[0].label;
                const info = chartMobile1.querySelector('.label-item') as HTMLElement;
                info.addEventListener('click', () => {
                    clearUi();

                    mask.classList.remove('d-none');
                    labelTooltip.classList.remove('d-none');
                    document.body.style.overflow = 'hidden';

                    const title = document.createElement('div');
                    title.classList.add('tooltip-title');
                    const description = document.createElement('div');
                    description.classList.add('tooltip-description');
                    title.textContent += data[0].tooltip.title;
                    description.textContent += data[0].tooltip.description;

                    labelTooltip.appendChild(title);
                    labelTooltip.appendChild(description);
                });

                // @ts-ignore
                const chart1 = new Chart(ctx1, {
                    type: 'bar',
                    data: {
                        labels: data.map((item: any) => item.label),
                        datasets: [
                            {
                                data: data[0].values.map((item: any) => item.value),
                                backgroundColor: data[0].color.map((item: any) => item),
                                hoverBackgroundColor: data[0].color.map((item: any) => item),
                            },
                        ],
                    },
                    options: {
                        datasets: {
                            bar: {
                                barThickness: 40,
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        scales: {
                            x: {
                                grid: {
                                    display: false,
                                },
                                ticks: {
                                    display: false,
                                },
                            },
                            y: {
                                grid: {
                                    display: true,
                                    color: '#ECE9F1',
                                    tickColor: 'transparent',
                                    tickLength: 39,
                                },
                                border: {
                                    display: false,
                                },
                                beginAtZero: true,
                                display: true,
                                ticks: {
                                    callback: function (value) {
                                        return value + ' %';
                                    },
                                    display: true,
                                    color: '#030303',
                                    font: {
                                        size: 20,
                                        weight: 'normal',
                                        family: "'Titillium Web', sans-serif",
                                    },
                                },
                            },
                        },
                        plugins: {
                            tooltip: {
                                callbacks: {
                                    label: function (context) {
                                        let label = context.formattedValue;
                                        return label + ' %';
                                    },
                                },
                                titleColor: '#000',
                                backgroundColor: '#FFF',
                                displayColors: false,
                                bodyColor: '#000',
                                enabled: true,
                            },
                            legend: {
                                display: false,
                            },
                        },
                    },
                });

                let ctx2 = bar.querySelector('#chart-mobile-2') as any;
                const chartMobile2 = mobileCarousel.querySelector('#chart-2') as HTMLElement;
                const labelSecondChart = chartMobile2.querySelector('.label') as HTMLElement;
                labelSecondChart.textContent += data[1].label;
                const info2 = chartMobile2.querySelector('.label-item') as HTMLElement;
                info2.addEventListener('click', () => {
                    clearUi();

                    mask.classList.remove('d-none');
                    labelTooltip.classList.remove('d-none');
                    document.body.style.overflow = 'hidden';

                    const title = document.createElement('div');
                    title.classList.add('tooltip-title');
                    const description = document.createElement('div');
                    description.classList.add('tooltip-description');
                    title.textContent += data[1].tooltip.title;
                    description.textContent += data[1].tooltip.description;

                    labelTooltip.appendChild(title);
                    labelTooltip.appendChild(description);
                });
                // @ts-ignore
                const chart2 = new Chart(ctx2, {
                    type: 'bar',
                    data: {
                        labels: data.map((item: any) => item.label),
                        datasets: [
                            {
                                data: data[1].values.map((item: any) => item.value),
                                backgroundColor: data[1].color.map((item: any) => item),
                                hoverBackgroundColor: data[1].color.map((item: any) => item),
                            },
                        ],
                    },
                    options: {
                        datasets: {
                            bar: {
                                barThickness: 40,
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        scales: {
                            x: {
                                grid: {
                                    display: false,
                                },
                                ticks: {
                                    display: false,
                                },
                            },
                            y: {
                                grid: {
                                    display: true,
                                    color: '#ECE9F1',
                                    tickColor: 'transparent',
                                    tickLength: 39,
                                },
                                border: {
                                    display: false,
                                },
                                beginAtZero: true,
                                display: true,
                                ticks: {
                                    callback: function (value) {
                                        return value + ' %';
                                    },
                                    display: true,
                                    color: '#030303',
                                    font: {
                                        size: 20,
                                        weight: 'normal',
                                        family: "'Titillium Web', sans-serif",
                                    },
                                },
                            },
                        },
                        plugins: {
                            tooltip: {
                                callbacks: {
                                    label: function (context) {
                                        let label = context.formattedValue;
                                        return label + ' %';
                                    },
                                },
                                titleColor: '#000',
                                backgroundColor: '#FFF',
                                displayColors: false,
                                bodyColor: '#000',
                                enabled: true,
                            },
                            legend: {
                                display: false,
                            },
                        },
                    },
                });

                if (slides.length === 3) {
                    let ctx3 = bar.querySelector('#chart-mobile-3') as any;
                    const chartMobile3 = mobileCarousel.querySelector('#chart-3') as HTMLElement;
                    const labelThirdChart = chartMobile3.querySelector('.label') as HTMLElement;
                    labelThirdChart.textContent += data[2].label;
                    const info3 = chartMobile3.querySelector('.label-item') as HTMLElement;
                    info3.addEventListener('click', () => {
                        clearUi();

                        mask.classList.remove('d-none');
                        labelTooltip.classList.remove('d-none');
                        document.body.style.overflow = 'hidden';

                        const title = document.createElement('div');
                        title.classList.add('tooltip-title');
                        const description = document.createElement('div');
                        description.classList.add('tooltip-description');
                        title.textContent += data[2].tooltip.title;
                        description.textContent += data[2].tooltip.description;

                        labelTooltip.appendChild(title);
                        labelTooltip.appendChild(description);
                    });
                    // @ts-ignore
                    const chart3 = new Chart(ctx3, {
                        type: 'bar',
                        data: {
                            labels: data.map((item: any) => item.label),
                            datasets: [
                                {
                                    data: data[2].values.map((item: any) => item.value),
                                    backgroundColor: data[2].color.map((item: any) => item),
                                    hoverBackgroundColor: data[2].color.map((item: any) => item),
                                },
                            ],
                        },
                        options: {
                            datasets: {
                                bar: {
                                    barThickness: 40,
                                },
                            },
                            responsive: true,
                            maintainAspectRatio: true,
                            scales: {
                                x: {
                                    grid: {
                                        display: false,
                                    },
                                    ticks: {
                                        display: false,
                                    },
                                },
                                y: {
                                    grid: {
                                        display: true,
                                        color: '#ECE9F1',
                                        tickColor: 'transparent',
                                        tickLength: 39,
                                    },
                                    border: {
                                        display: false,
                                    },
                                    beginAtZero: true,
                                    display: true,
                                    ticks: {
                                        callback: function (value) {
                                            return value + ' %';
                                        },
                                        display: true,
                                        color: '#030303',
                                        font: {
                                            size: 20,
                                            weight: 'normal',
                                            family: "'Titillium Web', sans-serif",
                                        },
                                    },
                                },
                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: function (context) {
                                            let label = context.formattedValue;
                                            return label + ' %';
                                        },
                                    },
                                    titleColor: '#000',
                                    backgroundColor: '#FFF',
                                    displayColors: false,
                                    bodyColor: '#000',
                                    enabled: true,
                                },
                                legend: {
                                    display: false,
                                },
                            },
                        },
                    });
                }

                swiper.init();
            }
        });
    }
}
